import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Knoxville (~100 mi) — no Kingsport walk-in",
      "NPIC appointment required before traveling to Knoxville",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no 100-mile Knoxville drive needed",
      "Ideal for Eastman Chemical executives with global partner meetings",
      "Perfect for BAE Systems defense contractors with overseas assignments",
      "Great for Sullivan County families with planned international trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Sullivan County post offices",
      "Good for planned international travel from TRI",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Sullivan County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function KingsportProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Kingsport"
      introText="Kingsport and Sullivan County travelers — Eastman Chemical executives with global partner meetings, BAE Systems defense contractors with overseas project assignments, Domtar and Ballad Health professionals with international conferences, and Kingsport families planning trips abroad — have several options for getting a passport fast. Here is how they compare, and why most Northeast Tennessee business travelers and residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the 100-mile drive to Knoxville."
      options={options}
      emergencyDescription="Kingsport does not have its own regional passport agency. The closest is the Knoxville Passport Agency — approximately 100 miles southwest, nearly 2 hours each way. For Eastman Chemical executives with last-minute international partner visits and BAE Systems contractors with confirmed overseas deployment dates, a 200-mile round trip through Appalachian highways with no appointment guarantee is not compatible with corporate schedules that operate on global timelines."
      disclaimerText="*Processing speed depends on eligibility and documentation. Kingsport does not have a regional passport agency — the closest is Knoxville, approximately 100 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}